import React from 'react';
import { Star } from 'lucide-react';
const comments = [{
  quote: 'Ahora sé qué hacer cuando pasa algo… antes me quedaba en lo mismo.',
  name: 'Sofía V.',
  role: 'Usuario'
}, {
  quote: 'Dejé de cargar cosas que ni siquiera entendía.',
  name: 'Daniela P.',
  role: 'Usuario'
}, {
  quote: 'Mi relación no es perfecta… pero ahora es mucho más liviana.',
  name: 'Gabriel S.',
  role: 'Usuario'
}];
export function TestimonialsPreGuarantee() {
  return <section className="py-5 px-5 bg-[#000000]" data-id="element-280">
      <div className="max-w-xl mx-auto" data-id="element-281">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-2" data-id="element-282">
          👨‍👩‍👧‍👦 Familias reales, resultados reales
        </h2>
        <p className="text-sm text-gray-500 text-center mb-8" data-id="element-283">
          Esto dicen quienes ya aplican el sistema
        </p>

        <div className="space-y-3" data-id="element-284">
          {comments.map((c, i) => <div key={i} className="bg-slate-900 border border-slate-800 p-4 rounded-xl" data-id="element-285">
              <div className="flex gap-0.5 mb-2" data-id="element-286">
                {[...Array(5)].map((_, j) => <Star key={j} size={12} className="fill-brand-yellow text-brand-yellow" data-id="element-287" />)}
              </div>
              <p className="text-slate-300 italic text-sm mb-2 leading-relaxed" data-id="element-288">
                "{c.quote}"
              </p>
              <div className="flex items-center gap-2" data-id="element-289">
                <div className="w-7 h-7 rounded-full bg-slate-700 flex items-center justify-center text-xs font-bold text-brand-yellow flex-shrink-0" data-id="element-290">
                  {c.name.charAt(0)}
                </div>
                <div data-id="element-291">
                  <p className="font-bold text-white text-xs" data-id="element-292">{c.name}</p>
                  <p className="text-[11px] text-slate-500" data-id="element-293">{c.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}